<template>
    <div class="workspace_self_user_info">
        <span class="workspace_self_user_info_inner" @click="toggleUserDropdown">
            {{ userInitials }}
            <i :class="onlineStatusClass" :title="onlineStatusTitle"></i>
        </span>

        <div class="workspace_self_user_info_dropdown" v-if="isDropdownOpen" v-click-outside="closeUserDropdown">
            <div class="row align-items-center">
                <div class="col-auto pr-2">
                    <span class="workspace_self_user_info_inner">
                        {{ userInitials }}
                        <i :class="onlineStatusClass" :title="onlineStatusTitle"></i>
                    </span>
                </div>
                <div class="col pl-0 text-center">
                    <ul class="workspace_self_user_status_list">
                        <li v-if="userInfo && userInfo.is_online">
                            <div name="type_model" class="dropdown custom_select_dropdown">
                                <div id="typeModelFilter" data-toggle="dropdown" class="form_control">{{
                                    userInfo.current_status }}</div>
                                <div aria-labelledby="typeModelFilter" class="dropdown-menu"
                                    style="height:140px;min-width:auto;">
                                    <div class="dropdown-menuin">
                                        <ul>
                                            <li v-for="status in availableStatuses" :key="status" class="dropdown-item"
                                                @click="updateUserStatus(status)">
                                                {{ status }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li v-else>Offline</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */

import { bus } from '@/main';
import commonSocket from '@/commonSocket/index.js';
import moment from 'moment';

export default {
    name: 'self-user-status',
    props: [],
    data() {
        return {
            isDropdownOpen: false,
            userInfo: null,
            availableStatuses: ['Available', 'Busy', 'At a Meeting', 'Be Right Back', 'Lunch Away'],
        };
    },
    computed: {
        userInitials() {
            if (this.userInfo) {
                return `${this.userInfo.first_name.charAt(0)}${this.userInfo.last_name.charAt(0)}`;
            }
            return '';
        },
        onlineStatusClass() {
            if (this.userInfo && this.userInfo.is_online) {
                const statusMap = {
                    'Available': 'available',
                    'Be Right Back': 'be_right_back',
                    'Lunch Away': 'lunch_away',
                    'Busy': 'busy',
                    'At a Meeting': 'at_a_meeting',
                };
                return `online-status ${statusMap[this.userInfo.current_status] || 'online'}`;
            }
            return 'online-status'; // Default for offline or no userInfo
        },
        onlineStatusTitle() {
            return this.userInfo && this.userInfo.is_online ? this.userInfo.current_status : 'Offline';
        },
    },
    async mounted() {
        await this.fetchUserInfo();
        this.setupSocketListener();
    },
    methods: {
        async fetchUserInfo() {
            try {
                const res = await this.$store.dispatch('getAcUserDetailsFun');
                this.userInfo = res.data.data;
            } catch (error) {
                console.error('Error fetching user details:', error);
            }
        },
        setupSocketListener() {
            bus.$on('userUpdateStatus', (data) => {
                const loggedInUserId = localStorage.getItem('LoginedUserID');
                if (data.userID === loggedInUserId) {
                    if (this.userInfo) {
                        this.userInfo.is_online = data.is_online;
                        if (data.current_status) {
                            this.userInfo.current_status = data.current_status;
                        }
                    }
                }
            });
        },
        toggleUserDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        closeUserDropdown() {
            this.isDropdownOpen = false;
        },
        async updateUserStatus(status) {
            this.closeUserDropdown(); 
            try {
                const payload = {
                    status_time: moment().format(),
                };
                if(status === "Be Right Back"){
                 payload.current_status = "Be right back";
                }else{
                 payload.current_status = status;
                }
                const formData = new FormData();
                formData.append('user', JSON.stringify(payload));

                await this.$store.dispatch('updateProfileFun', formData);

                if (this.userInfo) {
                    this.userInfo.current_status = status;
                }

                commonSocket.emit({
                    type: 'self_user_stat',
                    current_status: status,
                    status_time: moment().format(),
                });
            } catch (error) {
                console.error('Error updating user status:', error);
            }
        },
    },
    beforeUnmount() {
        bus.$off('userUpdateStatus');
    },
};
</script>

<style lang="scss" scoped>
.workspace_self_user_info {
    display: inline-block;
    margin-right: 8px;
    position: relative;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;

    .workspace_self_user_info_inner {
        background: #06ffff;
        display: inline-block;
        vertical-align: middle;
        width: 34px;
        text-align: center;
        height: 33px;
        line-height: 34px;
        border-radius: 50%;
        font-size: 16px;
        color: #000000;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        letter-spacing: 1px;
        position: relative;
        cursor: pointer;
    }

    .online-status {
        position: absolute;
        right: 0px;
        bottom: 3px;
        border: 1px solid #9E9E9E;
        border-radius: 50%;
        width: 8px;
        height: 8px;
        background: #9E9E9E;

        &.available {
            background-color: #38b124;
            border-color: #38b124;
        }

        &.be_right_back {
            background-color: #f3d32d;
            border-color: #f3d32d;
        }

        &.lunch_away {
            background-color: #1483E5;
            border-color: #1483E5;
        }

        &.busy {
            background-color: #ee0809;
            border-color: #ee0809;
        }

        &.at_a_meeting {
            background-color: #f66c11;
            border-color: #f66c11;
        }

        &.online {
            background-color: #4CAF50;
            border-color: #4CAF50;
        }

        &.away {
            background-color: #f1c40f;
            border-color: #f1c40f;
        }

        &.busy {
            background-color: #F44336;
            border-color: #F44336;
        }
    }

    .workspace_self_user_info_dropdown {
        position: absolute;
        right: 0;
        background: #008081;
        width: 180px;
        padding: 8px;
        border-radius: 4px;
        z-index: 1000;
        top: 41px;

        &::before {
            border: solid;
            border-color: #008081 transparent;
            border-width: 12px 12px 0px 0px;
            top: -6px;
            content: "";
            display: block;
            right: auto;
            position: absolute;
            z-index: 1000;
            -webkit-transform: rotate(135deg);
            transform: rotate(45deg);
            right: 5px;
        }
    }

    .workspace_self_user_status_list {
        margin: 0px 0px;
        display: flex;
        align-items: center;

        li {
            line-height: 1;

            // &:first-child{margin-right:5px;padding-right:5px;}
            select {
                background: none;
                border: none;
                outline: none;
                box-shadow: none;
                font-size: 16px;
                color: #fff;
                cursor: pointer;

                option {
                    color: #000000;
                    cursor: pointer;
                }
            }
        }
    }

    .workspace_self_user_name {
        font-size: 18px;
        line-height: 1;
        margin-bottom: 3px;
    }

    .workspace_self_user_email {
        font-size: 14px;
        margin: 0;
        color: #d7d7d7;
    }

    .custom_select_dropdown .form_control {
        background-color: rgba($color: #000000, $alpha: 0);
        height: auto;
        line-height: 1;
        padding: 0 25px 0 0;
        font-size: 16px;
        cursor: pointer;
    }

    .custom_select_dropdown .dropdown-menuin ul li {
        font-size: 16px;
        padding: 3px 5px;
        margin: 2px 0;
    }
}
</style>